import GarminRoutes from 'collections/course/GarminRoutes';
import Util from 'views/utils/LeafletMap/utils/Util';
import MapUtil from 'views/utils/LeafletMap/utils/MapUtil';
import DirectionService from 'views/utils/LeafletMap/MapServices/DirectionService';

var GarminDirectionService = function(args) {
    DirectionService.call(this, args);
    return this;
};

GarminDirectionService.prototype = Object.create(DirectionService.prototype);
GarminDirectionService.prototype.constructor = GarminDirectionService;

GarminDirectionService.prototype.updateTransitionMode = function updateTransitionMode(transitionMode) {
    if (transitionMode.parent) {
        if (transitionMode.parent === 'cycling' && transitionMode.value) {
            this.transitMode =
                Util.PopularityRouteTypes[transitionMode.value.toUpperCase()] || Util.PopularityRouteTypes.ROAD_CYCLING;
        } else if (transitionMode.parent === 'running' && transitionMode.value) {
            this.transitMode =
                Util.PopularityRouteTypes[transitionMode.value.toUpperCase()] || Util.PopularityRouteTypes.RUNNING;
        }
    } else {
        this.transitMode = Util.PopularityRouteTypes.RUNNING;
    }
};

GarminDirectionService.prototype.fetch = function fetch(options, context) {
    var routes = new GarminRoutes({
            startLat: options.start[0],
            startLon: options.start[1],
            endLat: options.end[0],
            endLon: options.end[1],
            courseType: this.transitMode
        }),
        points = [],
        meters = 0,
        i,
        point1,
        point2;

    return routes.fetch({
        success: function(collection, o, jqXHR) {
            if (options.success) {
                if (jqXHR.xhr.status === 200 && collection) {
                    collection.each(function(model) {
                        points.push([model.getLatitude(), model.getLongitude(), 0, 0]);
                    });

                    for (i = 0; i < collection.models.length - 1; i++) {
                        point1 = collection.models[i];
                        point2 = collection.models[i + 1];
                        meters += MapUtil.calculateDistanceBetweenPointsInMeters(
                            point1.getLatitude(),
                            point1.getLongitude(),
                            point2.getLatitude(),
                            point2.getLongitude()
                        );
                    }

                    options.success.call(context, { points: points, meters: meters });
                } else if (jqXHR.xhr.status === 204) {
                    options.error.call(context, jqXHR.xhr.statusText, jqXHR.xhr.status, Util.ErrorCodes.GENERIC);
                } else {
                    options.error.call(context, jqXHR.xhr.statusText, jqXHR.xhr.status, Util.ErrorCodes.GENERIC);
                }
            }
        },
        error: function(collection, jqXHR) {
            if (options.error) {
                options.error.call(context, jqXHR.statusText, jqXHR.status, Util.ErrorCodes.GENERIC);
            }
        }
    });
};

export default GarminDirectionService;
